import React from "react";
import { t, ArrowReload, Archive, CircleHelp, ShoppingCartIcon } from "../normalizer";
import CustomButton from "../shared/CustomButton";

// Row of voucher operations. Each button delegates to the parent, which owns
// the modal it opens (reorder / archive confirmation, help info).
const VoucherActionBar = ({ onReorderClick, onArchiveClick, onHelpClick, archiveDisabled }) => {
  return (
    <div className="voucher-action-bar">
      <CustomButton
        secondary
        type="button"
        className="voucher-action-bar-button"
        onClick={onReorderClick}
      >
        <ShoppingCartIcon className="voucher-action-bar-icon" />
        {t("gamification2026.voucher.actions.reorder")}
      </CustomButton>

      <CustomButton
        secondary
        type="button"
        className="voucher-action-bar-button"
        onClick={onArchiveClick}
        disabled={archiveDisabled}
      >
        <Archive className="voucher-action-bar-icon" />
        {t("gamification2026.voucher.actions.archive")}
      </CustomButton>

      <CustomButton
        secondary
        type="button"
        className="voucher-action-bar-button"
        onClick={onHelpClick}
      >
        <CircleHelp className="voucher-action-bar-icon" />
        {t("gamification2026.voucher.actions.help")}
      </CustomButton>
    </div>
  );
};

export default VoucherActionBar;
